import React from 'react';
import PropTypes from 'prop-types';
import { ScorersWrapper, Scorers, Scorer, GoalType, PlayerName } from './styles';

const MatchRowScorers = ({
  scorers, penaltyScorers, color, size, weight, marginLeft, font,
}) => {
  const formatName = (playerName) => {
    const shortName = playerName.substring(0, 1);
    const shortplayerName = playerName.split(' ');
    if (shortplayerName.length === 2) {
      return [
        `${shortName}. `,
        shortplayerName[1],
      ];
    } else if (shortplayerName.length === 3) {
      return [
        `${shortName}. `,
        `${shortplayerName[1]} `,
        shortplayerName[2],
      ];
    } else {
      return playerName;
    }
  };
  return (
    <ScorersWrapper>
      <Scorers
        marginLeft={marginLeft}
        color={color}
        size={size}
        weight={weight}
      >
        {scorers && scorers.map((scorer, index) => (
          <React.Fragment key={index}>
            {scorer && scorer.get('override') && process.env.REACT_APP_SITE === 'gazzetta' ?
              <Scorer
                font={font}
              >
                <PlayerName>
                  {scorer.getIn(['goalPlayerOverride', 'formatName'])}
                </PlayerName>
                {scorer.get('goalTypeOverride') && (scorer.get('goalTypeOverride') === 'Penalty') &&
                <GoalType font={font}>(rig.)</GoalType>
                }
                {scorer.get('goalTypeOverride') && (scorer.get('goalTypeOverride') === 'Own') &&
                <GoalType font={font}>(AG)</GoalType>
                }
                {scorer.get('goalAbsoluteTime') ? `${scorer.get('goalAbsoluteTime')}'` : ''}
              </Scorer> :
              <Scorer font={font}>
                <PlayerName>
                  {scorer.getIn(['goalPlayer', 'formatName'])}
                </PlayerName>
                {scorer.get('goalType') && (scorer.get('goalType') === 'Penalty') &&
                <GoalType font={font}>(rig.)</GoalType>
                }
                {scorer.get('goalType') && (scorer.get('goalType') === 'Own') &&
                <GoalType font={font}>(AG)</GoalType>
                }
                {scorer.get('goalAbsoluteTime') ? `${scorer.get('goalAbsoluteTime')}'` : ''}
              </Scorer>
            }
          </React.Fragment>
        ))}
        {penaltyScorers && penaltyScorers.map((pen, index) => {
          const playerName = pen.getIn(['penaltyPlayer', 'playerName']);
          const playerId = pen.getIn(['penaltyPlayer', 'playerId']);
          const goalOutCome = pen.get('goalOutCome');
          return (goalOutCome === 'Scored' && playerName && playerId &&
          <Scorer
            key={index}
            font={font}
          >
            <GoalType font={font}>(rig.)</GoalType>
            <PlayerName>
              {formatName(pen.getIn(['penaltyPlayer', 'playerName']))}
            </PlayerName>
          </Scorer>);
          })
        }
      </Scorers>
    </ScorersWrapper>
  );
};

MatchRowScorers.propTypes = {
  scorers: PropTypes.any,
  penaltyScorers: PropTypes.any,
  color: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.string,
  marginLeft: PropTypes.number,
  font: PropTypes.string,
};

export default MatchRowScorers;



// WEBPACK FOOTER //
// ./src/components/MatchRowScorers/index.js